import { useTranslation } from "react-i18next";
import {Checkbox, CheckboxProps, Col, DatePicker, Form, Input, Radio, Row,} from "antd";
import FormInput from "../../../../components/form-input/FormInput";
import {FormInstance} from "antd/lib";
import {FunctionComponent, useEffect, useMemo, useState} from "react";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";
import {get} from "lodash";
import {
  dataSurveyMethod,
  dataSurveyObject,
  dataSurveyTarget,
} from "../../../../pages/course-construction/survey-plan/constants/data";
import {RangePickerProps} from "antd/es/date-picker";
import dayjs from "dayjs";

const validations = {
  planTitle: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error("Vui lòng nhập tiêu đề."));
      }
      if (value && value.length > 512) {
        return Promise.reject(new Error("Giới hạn tối đa 512 ký tự."));
      }
      return Promise.resolve();
    },
  },
  planCode: {
    required: true,
    validator: (_: unknown, value: string) => {
      if (!value) {
        return Promise.reject(new Error("Vui lòng nhập mã kế hoạch."));
      }
      if (value && value.length > 512) {
        return Promise.reject(new Error("Giới hạn tối đa 512 ký tự."));
      }
      return Promise.resolve();
    },
  },
  surveyTarget: {
    required: true,
    message: "Vui lòng chọn mục tiêu."
  },
  surveyTargetCourse: {
    required: true,
    message: "Vui lòng chọn khóa học."
  },
  surveyTargetProgram: {
    required: true,
    message: "Vui lòng chọn chương trình học."
  },
  surveyTargetDescription: {
    required: true,
    message: "Vui lòng điền mô tả."
  },
  surveyMethod: {
    required: true,
    message: "Vui lòng chọn phương pháp khảo sát.",
  },
  executionTime: {
    required: true,
    message: "Vui lòng chọn thời gian thực hiện.",
  },
  surveyObject: {
    required: true,
    message: "Vui lòng chọn đối tượng.",
  },
  universityObject: {
    required: true,
    message: "Vui lòng chọn trường.",
  },
  universityCourse: {
    required: true,
    message: "Vui lòng chọn khóa học.",
  },
  universitySpecialized: {
    required: true,
    message: "Vui lòng chọn chuyên ngành.",
  },
};
const {TextArea} = Input;

type FormCreateSurveyProps = {
  form: FormInstance;
  dataOptions?: any;
  dataOptionsSurvey?: any;
  checkCloseData: boolean;
  dataDetail?: any;
  onFinish?: (values: any) => any;
  isOpenEdit: boolean;
};

const FormCreateSurvey: FunctionComponent<FormCreateSurveyProps> = ({
                                                                      form,
                                                                      dataOptions,
                                                                      dataOptionsSurvey,
                                                                      checkCloseData,
                                                                      dataDetail,
                                                                      onFinish,
                                                                      isOpenEdit,
                                                                    }) => {
  const { t } = useTranslation();
  const [selectedTarget, setSelectedTarget] = useState<number | null>(null);

  const localizedSurveyMethod = useMemo(
    () => dataSurveyMethod.map((item) => ({ ...item, label: t(item.label, item.label) })),
    [t]
  );
  const localizedSurveyObject = useMemo(
    () => dataSurveyObject.map((item) => ({ ...item, label: t(item.label, item.label) })),
    [t]
  );
  const localizedSurveyTarget = useMemo(
    () => dataSurveyTarget.map((item) => ({ ...item, label: t(item.label, item.label) })),
    [t]
  );

  const universityCheckboxValue = Form.useWatch('universityCheckbox', form)
  const registerCourseCheckboxValue = Form.useWatch('registerCourseCheckbox', form)
  const completedCourseCheckboxValue = Form.useWatch('completedCourseCheckbox', form)
  const specializedCheckboxValue = Form.useWatch('specializedCheckbox', form)
  const surveyObjectValue = Form.useWatch('surveyObject', form)
  const handleTargetChange = (index: any) => {
    const value = dataSurveyTarget[index - 1];
    setSelectedTarget(value.code);
  };


  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf("day");
  };


  const handleCheckedUniversity: CheckboxProps["onChange"] = (e) => {
    form.setFieldsValue({
      'universityCheckbox': e.target.checked
    })
  };
  const handleCheckedRegisterCourse: CheckboxProps["onChange"] = (e) => {
    form.setFieldsValue({
      'registerCourseCheckbox': e.target.checked
    })
  };
  const handleCheckedCompletedCourse: CheckboxProps["onChange"] = (e) => {
    form.setFieldsValue({
      'completedCourseCheckbox': e.target.checked
    })
  };
  const handleCheckedSpecialized: CheckboxProps["onChange"] = (e) => {
    form.setFieldsValue({
      'specializedCheckbox': e.target.checked
    })
  };


  // True: Đối tượng = Nhóm đối tượng cụ thể
  // False: Đối tượng = Bất kỳ ai có đường dẫn
  const renderAdditionalFieldsByObject = () => {
    if (surveyObjectValue) {
      return (
        <>
          <Col span={8} className="col-table-create">
            <Form.Item name="universityCheckbox">
              <Checkbox
                checked={universityCheckboxValue}
                onChange={handleCheckedUniversity}
              >
                {t("Theo trường", "Theo trường")}
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={16} className="col-table-create">
            <Form.Item
              className="object-form-item"
              name="universityList"
              label={t("Danh sách trường", "Danh sách trường")}
            >
              <FormItemDropdown
                options={get(dataOptions, "dataUniversity", [])}
                allowClear={true}
                placeholder={t("Chọn trường", "Chọn trường")}
                modeDropdown="multiple"
                disabled={!universityCheckboxValue}
              />
            </Form.Item>
          </Col>
          <Col span={8} className="col-table-create">
            <Form.Item name="registerCourseCheckbox">
              <Checkbox
                checked={registerCourseCheckboxValue}
                onChange={handleCheckedRegisterCourse}
              >
                {t("Theo khóa học đăng ký", "Theo khóa học đăng ký")}
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={16} className="col-table-create">
            <Form.Item
              className="object-form-item"
              name="registerCourseList"
              label={t("Danh sách khóa học đăng ký", "Danh sách khóa học đăng ký")}
            >
              <FormItemDropdown
                options={dataOptionsSurvey.filter((item: any) => item.status = 13)}
                allowClear={true}
                placeholder={t("Chọn khóa học", "Chọn khóa học")}
                modeDropdown="multiple"
                disabled={!registerCourseCheckboxValue}
              />
            </Form.Item>
          </Col>
          <Col span={8} className="col-table-create">
            <Form.Item name="completedCourseCheckbox">
              <Checkbox
                checked={completedCourseCheckboxValue}
                onChange={handleCheckedCompletedCourse}
              >
                {t("Theo khóa học hoàn thành", "Theo khóa học hoàn thành")}
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={16} className="col-table-create">
            <Form.Item
              className="object-form-item"
              name="completedCourseList"
              label={t("Danh sách khóa học hoàn thành", "Danh sách khóa học hoàn thành")}
            >
              <FormItemDropdown
                options={dataOptionsSurvey.filter((item: any) => item.status = 13)}
                allowClear={true}
                placeholder={t("Chọn khóa học", "Chọn khóa học")}
                modeDropdown="multiple"
                disabled={!completedCourseCheckboxValue}
              />
            </Form.Item>
          </Col>
          <Col span={8} className="col-table-create">
            <Form.Item name="specializedCheckbox">
              <Checkbox
                checked={specializedCheckboxValue}
                onChange={handleCheckedSpecialized}
              >
                {t("Theo chuyên ngành", "Theo chuyên ngành")}
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={16} className="col-table-create">
            <Form.Item
              className="object-form-item"
              name="specializedList"
              label={t("Danh sách chuyên ngành", "Danh sách chuyên ngành")}
            >
              <FormItemDropdown
                options={get(dataOptions, "dataSpecialized", [])}
                allowClear={true}
                placeholder={t("Chọn chuyên ngành", "Chọn chuyên ngành")}
                modeDropdown="multiple"
                disabled={!specializedCheckboxValue}
              />
            </Form.Item>
          </Col>
        </>
      );
    } else {
      return <></>;
    }
  };

  //   1: Mục tiêu = Khảo sát khóa học
  //   2: Mục tiêu = Khảo sát chương trình học
  //   3: Mục tiêu = khác
  const renderAdditionalFieldsByTarget = () => {
    switch (selectedTarget) {
      case 1:
        return (
          <Form.Item name="course" label={t("Khóa học", "Khóa học")} rules={[validations.surveyTargetCourse]}>
            <FormItemDropdown
              modeDropdown="multiple"
              options={get(dataOptions, "dataSurveyCourse", [])}
              allowClear={true}
              placeholder={t("Chọn khóa học", "Chọn khóa học")}
              // onChange={checkOnChange}
            />
          </Form.Item>
        );
      case 2:
        return (
          <Form.Item name="program" label={t("Chương trình học", "Chương trình học")} rules={[validations.surveyTargetProgram]}>
            <FormItemDropdown
              modeDropdown="multiple"
              options={get(dataOptions, "dataSurveyCurriculum", [])}
              allowClear={true}
              placeholder={t("Chọn chương trình học", "Chọn chương trình học")}
              // onChange={checkOnChange}
            />
          </Form.Item>
        );
      case 3:
        return (
          <Form.Item name="description" label={t("Mô tả", "Mô tả")} rules={[]}>
            <TextArea showCount maxLength={512} placeholder={t("Nhập mô tả", "Nhập mô tả")}/>
          </Form.Item>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    setSelectedTarget(null);
  }, [checkCloseData]);


  useEffect(() => {
    if (dataDetail.targetType) {
      setSelectedTarget(dataDetail.targetType);
    }
  }, [dataDetail]);


  return (
    <>
      <Form
        layout={"vertical"}
        form={form}
        onFinish={onFinish}
        name="createSurveyPlan"
        className="form-create-survey"
        initialValues={{
          'surveyMethod': true,
          'surveyObject': true,
        }}
      >
        <Row gutter={16}>
          <Col span={12} className="col-table-create">
            <Form.Item
              name="planTitle"
              rules={[validations.planTitle]}
              label={t("Tiêu đề", "Tiêu đề")}
            >
              <FormInput placeholder={t("Nhập tiêu đề", "Nhập tiêu đề")}/>
            </Form.Item>
          </Col>
          <Col span={12} className="col-table-create">
            <Form.Item
              name="planCode"
              label={t("Mã kế hoạch", "Mã kế hoạch")}
              rules={[validations.planCode]}
            >
              <FormInput placeholder={t("Nhập mã kế hoạch", "Nhập mã kế hoạch")}/>
            </Form.Item>
          </Col>
          <Col span={24} className="col-table-create">
            <div className="wrapper-radio">
              <Form.Item
                name="surveyMethod"
                label={t("Phương pháp khảo sát", "Phương pháp khảo sát")}
                rules={[validations.surveyMethod]}
              >
                <Radio.Group
                  options={localizedSurveyMethod}
                />
              </Form.Item>
            </div>
          </Col>
          <Col span={12} className="col-table-create">
            <Form.Item
              name="executionTime"
              label={t("Thời gian thực hiện", "Thời gian thực hiện")}
              rules={[validations.executionTime]}
            >
              <DatePicker.RangePicker
                allowClear
                format="DD/MM/YYYY"
                disabledDate={disabledDate}
                style={{width: "100%"}}
                placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
              />
            </Form.Item>
          </Col>
          <Col span={12} className="col-table-create">
            <Form.Item name="surveyTarget" label={t("Mục tiêu", "Mục tiêu")}
                       rules={[validations.surveyTarget]}
            >
              <FormItemDropdown
                options={localizedSurveyTarget}
                placeholder={t("Chọn mục tiêu", "Chọn mục tiêu")}
                onChange={handleTargetChange}
              />
            </Form.Item>
          </Col>
          <Col span={24} className="col-table-create">
            {renderAdditionalFieldsByTarget()}
          </Col>

          <Col span={24} className="col-table-create">
            <div className="wrapper-radio">
              <Form.Item
                name="surveyObject"
                label={t("Đối tượng", "Đối tượng")}
                rules={[validations.surveyObject]}
              >
                <Radio.Group
                  options={localizedSurveyObject}
                />
              </Form.Item>
            </div>
          </Col>
          {renderAdditionalFieldsByObject()}
        </Row>
      </Form>
    </>
  );
};

export default FormCreateSurvey;
